import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, WidthType, ImageRun, convertInchesToTwip } from "docx";
import { saveAs } from "file-saver";
import pdfImage from "../../components/PDF/pdfImage";

export const wordRPT114 = (dataReport_1, dataReport_2, setLoading) => {
    setLoading(true);

    const checkNull = (val) => {
        return val === null ? "" : val;
    };

    const font = {
        size: {
            p: 32,
            tbHeader: 32,
            tbbody: 32,
        },
        SarabunPSK: "TH SarabunPSK",
    };

    const viewPortwidth = 100;

    const p1 = new Paragraph({
        alignment: "center",
        children: [
            new TextRun({
                text: "บริษัท/ห้างฯ " + checkNull(dataReport_1[0].contractorName),
                bold: true,
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });
    const p2 = new Paragraph({
        alignment: "center",
        children: [
            new TextRun({
                text: "ใบแจ้งขอปฏิบัติงาน และรายการผลงานประจำวัน สัญญา/ข้อตกลงจ้าง " + dataReport_1[0].contractNo,
                bold: true,
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });
    const p3 = new Paragraph({
        alignment: "right",
        children: [
            new TextRun({
                text: "วันที่ " + dataReport_1[0].requestDate,
                bold: true,
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });
    const p4 = new Paragraph({
        children: [
            new TextRun({
                text: "เรียน นายช่างโครงการฯ /ผู้ควบคุมงาน",
                bold: true,
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });
    const p5 = new Paragraph({
        alignment: "center",
        children: [
            new TextRun({
                text: "ด้วยบริษัท/ห้างฯจะดำเนินการก่อสร้างวางท่อประปา ดังนี้",
                bold: true,
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });

    const p6 = new Paragraph({
        children: [],
    });

    // Begin Table 1
    const table = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        rowSpan: 2,
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ลำดับ/เส้นทาง",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 60,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "งานที่จะดำเนินการวันนี้",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        rowSpan: 2,
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ปริมาณ",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        rowSpan: 2,
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "บริเวณก่อสร้าง\n(กม.-กม.)",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        rowSpan: 2,
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ช่วงเวลาปฏิบัติงาน",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        rowSpan: 2,
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "หัวหน้างาน",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "สถานที่ และลักษณะงาน",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    for (const iterator of dataReport_1) {
        table.root.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.routeName,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 60,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.caseDesc,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.requestQuantity,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.locationDesc,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.operateTime,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.foreman,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            })
        );
    }
    // End Table 1

    // Begin Table 2
    const table2 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        rowSpan: 2,
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ลำดับ/เส้นทาง",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 50,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ผลงานวันที่  " + dataReport_1[0].requestDate,
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        rowSpan: 2,
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ปริมาณ",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        rowSpan: 2,
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "บริเวณก่อสร้าง\n(กม.-กม.)",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        columnSpan: 3,
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ผลงาน",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),

            new TableRow({
                width: {
                    size: viewPortwidth * 50,
                    type: WidthType.DXA,
                },
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "สถานที่ และลักษณะงาน",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ขนาด(มม.)",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 15,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "วันนี้",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 15,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ถึงวันนี้",
                                        bold: true,
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    for (const iterator of dataReport_2) {
        table2.root.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.resultRouteNo,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 60,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.resultCaseDesc,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.resultQuantity,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.resultLocation,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.resultSize,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.resultToday,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: viewPortwidth * 10,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: iterator.resultAccrue,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            })
        );
    }
    // End table 2

    const p7 = new Paragraph({
        alignment: "center",
        children: [
            new TextRun({
                text: "จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติ และจัดส่งเจ้าหน้าที่ไปควบคุมงานดังกล่าว ต่อไป",
                bold: true,
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });

    const p8 = new Paragraph({
        alignment: "right",
        children: [
            new TextRun({
                text: "กรรมการผู้จัดการ/หุ้นส่วนผู้จัดการ/วิศวกร/ผู้จัดการสนาม",
                bold: true,
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });

    // Begin Table 3
    const table3 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: viewPortwidth * 100,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: "ความเห็นของโครงการฯ/ผู้ควบคุมงาน",
                                        bold: true,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: viewPortwidth * 100,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",

                                children: [
                                    new ImageRun({
                                        data: dataReport_1[0].flag1 === "Y" ? pdfImage.checkBox : pdfImage.unchecked,
                                        transformation: {
                                            width: 15,
                                            height: 15,
                                        },
                                    }),
                                    new TextRun({
                                        text: "    เห็นชอบให้ดำเนินการลำดับ/เส้นทางที่",
                                        bold: true,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: viewPortwidth * 100,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new ImageRun({
                                        data: dataReport_1[0].flag2 === "Y" ? pdfImage.checkBox : pdfImage.unchecked,
                                        transformation: {
                                            width: 15,
                                            height: 15,
                                        },
                                    }),
                                    new TextRun({
                                        text: "    ไม่อนุญาตให้ดำเนินการลำดับที่/เส้นทางที่",
                                        bold: true,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: viewPortwidth * 100,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new ImageRun({
                                        data: dataReport_1[0].flag3 === "Y" ? pdfImage.checkBox : pdfImage.unchecked,
                                        transformation: {
                                            width: 15,
                                            height: 15,
                                        },
                                    }),
                                    new TextRun({
                                        text: "    อื่น",
                                        bold: true,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: viewPortwidth * 100,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: "บันทึกสั่งการ",
                                        bold: true,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: viewPortwidth * 100,
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: dataReport_2[0].remark === "" ? " " : dataReport_2[0].remark,
                                        bold: true,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });
    // End Table 3

    const p9 = new Paragraph({
        alignment: "right",
        children: [
            new TextRun({
                text: "นายช่างโครงการฯผู้ควบคุมงาน",
                bold: true,
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });

    const space = new Paragraph({
        children: [],
    });

    const doc = new Document({
        sections: [
            {
                children: [p1, p2, p3, p4, p5, table, p6, space, space, table2, p7, space, space, space, p8, table3, space, space, space, p9],
            },
        ],
    });

    Packer.toBlob(doc).then((blob) => {
        setLoading(false);
        saveAs(blob, "PRT114.docx");
    });
};
